import { AutologoutPanel } from '@/components/AutologoutPanel';
import { signOutScope } from '@/utils/session';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

interface Props {
  withoutModals?: boolean;
}

const Autologout = ({ withoutModals }: Props) => {
  const navigate = useNavigate();
  const getLastActive = () => localStorage.getItem('lastActive') ?? null;
  const setLastActive = (date: string) => localStorage.setItem('lastActive', date);
  const [showModal, setShowModal] = useState(false);
  const [timeEnded, setTimeEnded] = useState(false);

  const checkActivity = () => {
    const storedTime = new Date(getLastActive() as string).getTime();
    const currentTime = new Date().getTime();
    const timeDifference = currentTime - storedTime;

    if (getLastActive() && timeDifference > 15 * 60 * 1000) {
      setShowModal(true);
      setTimeEnded(timeDifference > 17 * 60 * 1000);
    }
  };

  const handleLogout = () => {
    Cookies.get('accessToken') &&
      signOutScope()
        .then((_resp: any) => navigate('log-in'))
        .catch(err => console.log(err.data.message));
  };

  useEffect(() => {
    const updateLastActive = () => {
      const newLastActive = new Date().toISOString();
      Cookies.get('accessToken') && setLastActive(newLastActive);
    };

    const intervalId = setInterval(checkActivity, 10000);

    document.addEventListener('mousemove', updateLastActive);
    document.addEventListener('keydown', updateLastActive);
    localStorage.setItem('lastActive', new Date().toISOString());

    checkActivity();

    return () => {
      document.removeEventListener('mousemove', updateLastActive);
      document.removeEventListener('keydown', updateLastActive);
      localStorage.removeItem('lastActive');
      clearInterval(intervalId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className='z-[9999]'>
      {showModal && !withoutModals && <AutologoutPanel isOpen={showModal} setIsOpen={setShowModal} timeEnded={timeEnded} />}
      <>{timeEnded && withoutModals && handleLogout()}</>
    </div>
  );
};

export default Autologout;
